/*
 * @Descripttion:
 * @version:
 * @Author: HeYang
 * @Date: 2019-08-07 15:59:45
 * @LastEditors: HeYang
 * @LastEditTime: 2020-11-11 11:27:17
 */
import axios from 'axios';
import { throwErr } from './code'; // 捕捉服务端http状态码的方法
import { Indicator } from 'mint-ui';
import { Toast } from 'vant';
import qs from 'qs';
import store from '@/store/index';
import { getParams, isLjds, isSandbox } from '@/common/utils/tools';
import { getOsVersion } from '../common/utils/util';
import { dataformat } from '@/common/js/format';

export { axios };

axios.interceptors.request.use(
    (config) => {
        config.timeout = 20 * 1000; // 请求响应时间
        let { token, platform, deviceId, appChannel, version } = store.state.login;

        if (process.env.NODE_ENV === 'development') {
            // 灵风
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2Mjk0NTUzODUxMDAwMDAwMCIsImlhdCI6MTYyOTY5MTU3OSwiZXhwIjoxNjYxMjI3NTc5fQ.kA5_OKuaQxztagVSVAOZCKJOIcYr6zioCARrOaRDgvM';
            //思远
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MTA1MDg2NDUwMDAwMDA4MCIsImlhdCI6MTYxMDUwODc2NywiZXhwIjoxNjQyMDQ0NzY3fQ._atr-Bu743xs8USi5H-kRMQnrvXXgtKw7MCAuyK-11Q';
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1ODc5ODgzMjUwMDAwMDAxMCIsImlhdCI6MTYwMjc2MjA2NSwiZXhwIjoxNjM0Mjk4MDY1fQ.NgY2IC6grChTTDpoaa9-T0XBPQx8xqjJLMeYNkikyMg';
            // 晓言
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MTczNTEzOTkwMDEwMDAxMCIsImlhdCI6MTYxNzY5OTQyMCwiZXhwIjoxNjQ5MjM1NDIwfQ.790ee-74xptRjLiDnN4K48M32gSb98rB7zVlQb4XqvE';
            // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MDMyNzczMjMwMDAwMDA1MCIsImlhdCI6MTYyMjQ0MjEzOCwiZXhwIjoxNjUzOTc4MTM4fQ.FcMl2TJJBInJ2KskXTbWtpmJfnfItrfFKniBFSPynGY";
            // 大河
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1MDgzMTAxNTcwMDAwMDA2MCIsImlhdCI6MTYxNDM5NjAxNywiZXhwIjoxNjQ1OTMyMDE3fQ.-qasQLXy5lZAf-aT1dnFQRpJ-3zWCNk2MHgjDJPAM_E';
            // 若云
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1ODQzMzkwNzkwMDAwMDAwMCIsImlhdCI6MTU5NDYyODI2MCwiZXhwIjoxNjI2MTY0MjYwfQ.9VbqRL3ZX-LDLnX45uBi6_WD_35Qz6j4hftRx-r2UV8';
            // 叶子
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1NDg4MzE3MTcwMDAwMDAxMCIsImlhdCI6MTU5MjE4OTAxMSwiZXhwIjoxNjIzNzI1MDExfQ.01es2CTx7Fsw5wfO6XxOfHheJjtdOLX57STRvmtG24Q';
            // 玄成
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1NTA0NzM3MjQwMDAwMDA0MCIsImlhdCI6MTU3ODM4MjgwNSwiZXhwIjoxNjA5OTE4ODA1fQ.02da0beHK028DktOADWgUb0EFTwF6GkMP4qBlwEXEkw';
            // 卡卡
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1NzU1Mjc3MjgwMDAwMDA4MCIsImlhdCI6MTU5OTA0NTUyMywiZXhwIjoxNjMwNTgxNTIzfQ.lHfqxxW0Js5ScthTcL1jtcQAfJSQ8VYO56dKOEuI9PE';
            // 红莲
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjU2MTAxIiwiaWF0IjoxNjAwNDExMTkyLCJleHAiOjE2MzE5NDcxOTJ9.C-XpvipBj9WToXjuUCnMjb30gg8a--xT2uIufSRcfYM'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1MDU0NDc3NTYiLCJpYXQiOjE2MjEzMDMyMDYsImV4cCI6MTY1MjgzOTIwNn0.k9OOyQ6aHJrJdp-IHdkdg0JDct1w_859QMD6k5fTDR8'
            // 红茶
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1OTc2NTY4NTIwMDAwMDAyMCIsImlhdCI6MTYwMzUzMTQ3MiwiZXhwIjoxNjM1MDY3NDcyfQ.ZwR_awI_siXPSB0d5_yWD6IBhsvgA5kNC5bnj9x5HRI';
            // 晓言
            // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1OTU1ODU3MzQwMDAwMDA0MCIsImlhdCI6MTYwMjc1MTMzMywiZXhwIjoxNjM0Mjg3MzMzfQ.rzi2RaN2vbv4-Kmu5un6ZhXBhgKU-bV9KdrGmTcqi14"
            // 星尘
            // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MTg0NzcxNzQwMDEwMDA0MCIsImlhdCI6MTYxODQ3NzI0MiwiZXhwIjoxNjUwMDEzMjQyfQ.tnDeHucaqBQtMTKWHSr2Ffhdnk5ApF6PNrAAN65RPK0"
            // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MTg0NzcxNzQwMDEwMDA0MCIsImlhdCI6MTYxODQ3NzI0MiwiZXhwIjoxNjUwMDEzMjQyfQ.tnDeHucaqBQtMTKWHSr2Ffhdnk5ApF6PNrAAN65RPK0"
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1NTcyMTU1MTUwMDAwMDA2MCIsImlhdCI6MTYyNTQ2ODM4NywiZXhwIjoxNjU3MDA0Mzg3fQ.lJw3k2EScm7U3zvFV8z7380_R2Thc2OF0n8EYG7t188'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1OTI0NDQ2NDUwMDAwMDA3MCIsImlhdCI6MTYyNTU1Mjk1NCwiZXhwIjoxNjU3MDg4OTU0fQ.5lmiq1wPZ6wxTFsfPLl1PYZ2harCUtaHw2sSvxfEs2o'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MjU2Mzg5NjMxMDAwMDA1MCIsImlhdCI6MTYyNjY4NTA2MSwiZXhwIjoxNjU4MjIxMDYxfQ.Y4qgmpeLveZsV_2Tn3GB5e0ZEdtZrfeN-lDqVA4eSPk'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MjQzNTg0NzgwMDEwMDA5MCIsImlhdCI6MTYyNzg4NTIyMiwiZXhwIjoxNjU5NDIxMjIyfQ.Nin_9ll0Y9O8VZ_xjn1iJ6j3iukRm_PD9pLtgGOiV_k'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MjYzNDI4ODExMDAwMDAyMCIsImlhdCI6MTYyNzg3NTk3MSwiZXhwIjoxNjU5NDExOTcxfQ.--BW4pxAc0clKPoJE5RyhlyGJ2TWIsftaPBtLFZYzVs'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MjYzNDI4ODExMDAwMDAyMCIsImlhdCI6MTYyNzk3Mjk3NCwiZXhwIjoxNjU5NTA4OTc0fQ.EitEd8M7tM0ld5Qt02dP9DugzryjSjWX2RXCVXDoR5w'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MjIwODkwMDEwMDEwMDA3MCIsImlhdCI6MTYyNzk5MDcwNSwiZXhwIjoxNjU5NTI2NzA1fQ.9bArh4CEfwFOd6A8PoJyExF2r_lH6L8rXF2EhwH2ITU'
            // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MzQxMjA0NDgxMDAwMDA0MCIsImlhdCI6MTYzNTkzMTMyMCwiZXhwIjoxNjY3NDY3MzIwfQ.-q6rRoiOgCy8290vC8YesYB5vxXgY6FAXB6ntcamxn8";
            // token =
            //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2MzQxMjA0NDgxMDAwMDA0MCIsImlhdCI6MTYzNTkzMTMyMCwiZXhwIjoxNjY3NDY3MzIwfQ.-q6rRoiOgCy8290vC8YesYB5vxXgY6FAXB6ntcamxn8";
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2Mjg3NjE3MjQxMDAwMDAzMCIsImlhdCI6MTYyOTg4NTAzNiwiZXhwIjoxNjYxNDIxMDM2fQ.4CuK6TeB-Q5YiPAK-l7VxXn6-LFXD8ZHNwooyC_riCs'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1MDgzMTAxNTcwMDAwMDA2MCIsImlhdCI6MTYzOTU2NzI5NiwiZXhwIjoxNjcxMTAzMjk2fQ.NeShjDsBPtecOjo1L1_7Fxd4QahWIhT26e6f1QuHVKc';
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NDI4MTcyMTAxMDAwMDA2MCIsImlhdCI6MTY0MzI3ODg2MSwiZXhwIjoxNjc0ODE0ODYxfQ.ymxG5dcwe7rLZH1u4i_i2NUuw3Sx4DSKzeiiantV7_A';
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NDU0NDUyOTIxMDAwMDA1MCIsImlhdCI6MTY0NjM2MjUxMCwiZXhwIjoxNjc3ODk4NTEwfQ.Ij3UP6U8vAfhsRDLTEOpCQPNgatd_GER4MRXkYvwt2k'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1MDgzMTAxNTcwMDAwMDA2MCIsImlhdCI6MTY0NzQ4OTk0MSwiZXhwIjoxNjc5MDI1OTQxfQ.u1Gp3pK-dZhVMxh4Ck-D91CGHnJqlTcYUi7MWbLuyG0'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NDc0ODM5ODkxMDAwMDA0MCIsImlhdCI6MTY0NzUwMTY1MywiZXhwIjoxNjc5MDM3NjUzfQ.-XvxXmo5lY6YCtlu-34O-PYcmHh-Slxho0Aim4HNJnw'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NDc4NDc1NTUwMDAwMDA3MCIsImlhdCI6MTY0Nzg0OTY4OSwiZXhwIjoxNjc5Mzg1Njg5fQ.FbrST_I4YEscgRI0VJ-9Px1asjTjkAoawoTb1B2U8Dk'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2Mzc2NzA1NDkxMDAwMDA2MCIsImlhdCI6MTY0ODEwMzkyNiwiZXhwIjoxNjc5NjM5OTI2fQ.RvPDOaF9lmS9xobh9p1uq2lUo1zjZMio1BUe7gqG7Jo'
            // token =
            // token ||
            //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1MDgzMTAxNTcwMDAwMDA2MCIsImlhdCI6MTY1NDgzMjM0NCwiZXhwIjoxNjg2MzY4MzQ0fQ.UbMGz8oCuj0l97AVLYrp9VMHYNiM7PPaNF7bq6aJJlU";
            // "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NTI0MTA5MDMxMDAwMDA2MCIsImlhdCI6MTY1MjY2Njg4OCwiZXhwIjoxNjg0MjAyODg4fQ.-Shk5TYqrSZlh9V2vkvuXfQjJy7gH6oyuhnCbxPCbes";
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NTUyODY1NDIxMDAwMDA2MCIsImlhdCI6MTY1NTQ1NjkxOCwiZXhwIjoxNjg2OTkyOTE4fQ.VFhC8Nts01yEVVUFTft37rQCRsWj-2CxDWoN4V5Ub6E '
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NTYwNjQyMzYxMDAwMDA4MCIsImlhdCI6MTY1NjM4NTYxMCwiZXhwIjoxNjg3OTIxNjEwfQ.9JFDaMyTxKLUPoS6BC-4nQce9lsUU-5dCAG1Y1I0kMg'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NTcxODU5MjgxMDAwMDAwMCIsImlhdCI6MTY1NzI0OTIzMywiZXhwIjoxNjg4Nzg1MjMzfQ.ds9R44HwPRNGSajElLZmvVoH4gMycbd7hfBcbGYJRzU'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NTgyMTI2NjQxMDAwMDA0MCIsImlhdCI6MTY1OTA3NjM5MywiZXhwIjoxNjkwNjEyMzkzfQ.N-T2DxfNGppCNj1gMgk2uIKwEhVwykgTbHWXfc5NXkU'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2Mzc2NzA1NDkxMDAwMDA2MCIsImlhdCI6MTY1OTA4MzYzNCwiZXhwIjoxNjkwNjE5NjM0fQ.K44wop3eTwTTFRwobT8TkjAFQGRQ6D46QtktiArgvfw'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjYyNTkwNzcxMDAwMDAzMCIsImlhdCI6MTY2NjI1OTA3OCwiZXhwIjoxNjk3Nzk1MDc4fQ.Upc8JlEKqPZbsJE8z8Nb9dyNSM1owgaGKNpOyJxr9I4'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjYzNDU3NDYxMDAwMDAwMCIsImlhdCI6MTY2NjM0NTc0NywiZXhwIjoxNjk3ODgxNzQ3fQ.Btk0p_5i_gtlubNzn2u7KQu0PGndjDME3SI4WIvkmog'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY0MDY1MTcxMDAwMDA4MCIsImlhdCI6MTY2NjQwNjUxOCwiZXhwIjoxNjk3OTQyNTE4fQ.BoKMIO3FgRli9DChotRkw1ZjEIphAQICIW7LcddqebY'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY0MDgzMzQxMDAwMDA5MCIsImlhdCI6MTY2NjQwODMzNCwiZXhwIjoxNjk3OTQ0MzM0fQ.aM4e4dmt_ZTUsVc351Qpx5uzd8XcAKGwXBzrqhtAiYo'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjYxNjYyOTkxMDAwMDAyMCIsImlhdCI6MTY2NjQwNDk2NiwiZXhwIjoxNjk3OTQwOTY2fQ.49vs2pSu5hCqURr9Abo_R2eKN2NVUBhuA08iLFhMnXM'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY0MjY4MzgxMDAwMDA3MCIsImlhdCI6MTY2NjQyNjgzOSwiZXhwIjoxNjk3OTYyODM5fQ.oMxB3ybYfRpqnOxf-VMwl2Axg13rrE7p3ZA4yan1SBU'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY0MjczMTUxMDAwMDAwMCIsImlhdCI6MTY2NjQyNzMxNSwiZXhwIjoxNjk3OTYzMzE1fQ.HMyO0n_DdF7En4tNJ4FGNk2rG9OBbJSB5A19XIbTfXw'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY0Mjk0ODExMDAwMDA2MCIsImlhdCI6MTY2NjQyOTQ4MSwiZXhwIjoxNjk3OTY1NDgxfQ.UO2Nn8owWJ8Qm6GSjzyXaTOjBO-9GmssO2BFvlfSwKk'
            // 测服
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY2OTAwNjkxMDAwMDA4MCIsImlhdCI6MTY2NjY5MDA3MCwiZXhwIjoxNjk4MjI2MDcwfQ._2Ln9CFP7S0RZYgqJpLx5Z8i69UFmwRBOyoDJurRHIw'
            // 老师
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2Mzc2NzA1NDkxMDAwMDA2MCIsImlhdCI6MTY2Nzk2NTA2MSwiZXhwIjoxNjk5NTAxMDYxfQ.pizWtjpN9Dxh4jK56bZuJiwDaFvwsa5vuiIw3nLwcEw'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NDgxOTY3ODMxMDAwMDA1MCIsImlhdCI6MTY2ODQ3OTIwMiwiZXhwIjoxNzAwMDE1MjAyfQ.Id-6skrPVebdmhUMhTsMLYcwH8IPI0Td4uDHhahLzjA'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NDgxOTY3ODMxMDAwMDA1MCIsImlhdCI6MTY2ODUwMDI1NSwiZXhwIjoxNzAwMDM2MjU1fQ.TzNmsQ4qjeolg1hvSwyEnRcYHVIZDlmSspRqAjyqZXA'
            // 老师助理
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6Ijc1NjI1IiwiaWF0IjoxNjY4NTY2ODk0LCJleHAiOjE3MDAxMDI4OTR9.6KjAMU8zOwONEbyDXRn6rUA2v81QejcNAodHZOqQRA8'
            // 正式

            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjA3Mjg5MjMwMDAwMDAyMCIsImlhdCI6MTY2NjY2NDEwNSwiZXhwIjoxNjk4MjAwMTA1fQ.sAuGeXKNiDnUQNf1CW9UzqCcO0bbl9EpBZA9RU2ui9U'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY2NjYwMTcwMDAwMDAxMCIsImlhdCI6MTY2NjY2ODgwMywiZXhwIjoxNjk4MjA0ODAzfQ.rgufcPvy5N31Di8mAFxOlpscI729eoZYBnf5MsG-kgM'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY0MjU5NzMwMDAwMDA2MCIsImlhdCI6MTY2NjY3OTExMSwiZXhwIjoxNjk4MjE1MTExfQ.O9RNiXPi40C2vRgndYWByg6leACYQj6Ccd5AjugAHIU'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NjY2NjgxMjgwMDAwMDEwMCIsImlhdCI6MTY2NjY4MTMyNSwiZXhwIjoxNjk4MjE3MzI1fQ.2dj78ZbvEyFRC_hrBErZAyzbUQuVrFsBbmJZWnM4Aqs'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2Njk2MDM4OTAxMDAwMDA0MCIsImlhdCI6MTY2OTYyNTAzOCwiZXhwIjoxNzAxMTYxMDM4fQ.iPxiyNaCxxLL_iUceV9OIwPARBOCQFIrt8s3cFPk43s'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2NzcyMDYwNjE3MzI2NjYyNCIsImlhdCI6MTY3NzIwNjA2MiwiZXhwIjoxNzA4NzQyMDYyfQ.p7XNzjYtLF-kY5sOLdq69VtdWkWbRbFadOLG8ZL6hS8'
            // token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2ODE4ODkyNjkxNDMxMDI0MCIsImlhdCI6MTY4MjIxNzM5OCwiZXhwIjoxNzEzNzUzMzk4fQ.D2W4MdbuJxS0ttbIA0Z4hpepstDcEaDftnEClmxLTFs'
            // token = token || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE2ODM2MjE1NDY1MDAxMDI0MiIsImlhdCI6MTY4MzcxNDU0NCwiZXhwIjoxNzE1MjUwNTQ0fQ.LZN6rjEjTERm6aX8Xzl9sMm0XFaaFoW59sPDLss7w7E'
            // TODO
            // platform = 38;
            // platform = 16;
            // platform = 23;
            deviceId = '00008020-0003293002F8002E';
            appChannel = 'appstore';
            console.log(`development ---`);
        }

        if (token && platform && deviceId && appChannel) {
            config.headers['YQW-Token'] = token;
            config.headers['platform'] = platform;
            config.headers['platformid'] = platform;
            config.headers['Authorization'] = token;
            config.headers['DeviceId'] = deviceId;
            config.headers['Publisher-Id'] = 4;
            config.headers['channel'] = appChannel;
            config.headers['version'] = version;
            // TODO
            store.commit('login/UPDATE_TOKEN', token);
            store.commit('login/UPDATE_PLATFORM', platform);
            store.commit('login/UPDATE_DEVICEID', deviceId);
            store.commit('login/UPDATE_APPCHANNEL', appChannel);
            store.commit('login/UPDATE_VERSION', version);
            localStorage.setItem('platform', platform);
        } else {
            if ((localStorage.getItem('tToken'))) {
                console.log(`set tToken`);

                config.headers['Publisher-Id'] = 6;
                config.headers['Authorization'] = localStorage.getItem('tToken');
                config.headers['YQW-Token'] = localStorage.getItem('tToken');
            }
        }

        try {
            if (
                (config.params && config.params._noToken) ||
                (config.data && config.data.match('_noToken=1'))
            ) {
                config.headers['Authorization'] = '';
                config.headers['YQW-Token'] = '';
            }
        } catch (err) {}

        console.log(token, 'token');
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    (response) => {
        let { code, msg, data } = response.data;
        console.log(response, '===response===');
        if (code === 200 || code === 1117 || code === 1 || code === 3603 || code === 3602) {
            // 服务端定义的响应code码为1时请求成功
            return Promise.resolve(data); // 使用Promise.resolve 正常响应
        } else if (code === 1007 || code === 1010) {
            Indicator.close();
            // 从localstorage的noLoginToast判断是否需要弹出Toast、调客户端的登录
            const needToast = localStorage.getItem('noLoginToast') || '1';
            needToast === '1' && Toast(msg);
            if (isLjds() && needToast === '1') {
                (window as any).mmc.user.login(() => {
                    location.reload();
                });
                return Promise.resolve();
            } else {
                localStorage.setItem('noLoginToast', '1');
                return Promise.reject(msg);
            }
        } else {
            Indicator.close();
            msg && Toast(msg);
            return Promise.reject(msg);
        }
    },
    (error) => {
        Indicator.close();
        console.log(error, '===error===');
        // 错误上报数据
        let errObj: apiErrorObj = {};
        const { response, request, config = {}, message = '' } = error;
        if (response) {
            const { status = '', config = {}, data = {} } = response;
            let res = {
                msg: throwErr(status, response),
            };
            Toast(res.msg);
            errObj = {
                api: config.url || '',
                status,
                responseData: data,
                requestData: config.params || config.data || '', // get请求：config.params；post请求：config.data
            };
            errReport(errObj);
            return Promise.reject(res);
        } else if (request) {
            const { status = '', response } = request;
            Toast(response);
            errObj = {
                api: config.url || '',
                status,
                responseData: response || message,
                requestData: config.params || config.data || '',
            };
            errReport(errObj);
            return Promise.reject(response);
        } else if (message) {
            Toast(message);
            errObj = {
                api: config.url || '',
                responseData: message,
            };
            errReport(errObj);
        } else {
            Toast('网络错误');
        }
        return Promise.reject(error);
    }
);

export default function request(method: string, url: string, data?: any, options?: {}) {
    // 暴露 request 给我们好API 管理
    method = method.toLocaleLowerCase(); // 封装RESTful API的各种请求方式 以 post get delete为例
    let channel = getParams('channel') || localStorage.getItem('channel') || '';
    if (!data.channel) {
        data.channel = channel;
    }
    if (method === 'post') {
        //return axios.post(url, qs.stringify(data))  // axios的post 默认转化为json格式
        if (options) {
            return axios.post(url, data, options); // axios的post 默认转化为json格式
        } else {
            return axios.post(url, qs.stringify(data)); // axios的post 默认转化为json格式
        }
    } else if (method === 'get') {
        data.retimestamp = new Date().getTime();
        return axios.get(url, { params: data });
    }
}

// 接口请求失败上报
interface apiErrorObj {
    api?: string;
    status?: number | string;
    responseData?: any;
    requestData?: any;
}
const errReport = (errObj: apiErrorObj) => {
    try {
        if (!isSandbox() && errObj) {
            let osVersion = getOsVersion();
            if (osVersion.indexOf('Android') > -1 && Number(osVersion.slice(7, 8)) < 6) {
                return;
            }
            (window as any).BJ_REPORT &&
                (window as any).BJ_REPORT.report({
                    msg: JSON.stringify(errObj),
                    from: window.location.href,
                    target: errObj.api || '',
                });
        }
    } catch (error) {
        console.log(error);
    }
};
